<div class="container" style="padding-bottom: 40px;">
  <div style="text-align: center;margin-top: 40px;">
    <mat-form-field>
      <mat-label>{{stringsService.strings['AWAIT_EXPORT_UNTIL']}}</mat-label>
      <input matInput type="date" [disabled]="!interfaceChangesEnabled" [ngModel]="employee.await_export_until | date:'yyyy-MM-dd'" name="employee.await_export_until" (ngModelChange)="employee.await_export_until = dateService.validate($event); setAwaitUntil();">
    </mat-form-field>
  </div>
  <div class="app">
    <div class="app-icon-holder">
      <img class="app-icon" src="assets/img/workday-logo.png">
    </div>
    <div class="connection">
      @if (employee.import_from_workday()) {
        <div class="connected">{{stringsService.strings['CONNECTED_TO_INTERFACE']}} &#10003;</div>
      }
      @if (!employee.import_from_workday()) {
        <div class="not-connected">{{stringsService.strings['NOT_CONNECTED']}} &#10007;</div>
      }
    </div>
    <div class="interface-connection">
      @if (employee.source_id !== 1) {
        <p class="invalid" style="color: orange;">{{stringsService.strings['REQUIRED_WORKDAY_SOURCE_ID']}}</p>
      }
    </div>
    @if (!employee.import_from_workday()) {
      <button id="merge" (click)="mergeEmployee()">{{stringsService.strings['MERGE_WITH_WORKDAY']}}</button>
    }
  </div>
  <div style="clear:both"></div>
  <div class="app">
    <div class="app-icon-holder">
      <img class="app-icon" src="assets/img/ows-logo.png">
    </div>
    <div class="connection">
      @if (employee.export_to_ows()) {
        <div class="connected">{{stringsService.strings['CONNECTED_TO_INTERFACE']}} &#10003;</div>
      }
      @if (!employee.export_to_ows()) {
        <div class="not-connected">{{stringsService.strings['NOT_CONNECTED']}} &#10007;</div>
      }
    </div>
    <div class="interface-connection">
      @if (employee.current_contract && employee.current_contract.start_date) {
        <p class="valid">{{stringsService.strings['CURRENT_CONTRACT']}}</p>
      }
      @if (!employee.current_contract || !employee.current_contract.start_date) {
        <p class="invalid">{{stringsService.strings['CURRENT_CONTRACT']}}</p>
      }
    </div>
  </div>
  <div style="clear:both"></div>
  <div class="app">
    <div class="app-icon-holder">
      <img class="app-icon" src="assets/img/paloma-logo.jpg">
    </div>
    <div class="connection">
      @if (employee.export_to_paloma()) {
        <div class="connected">{{stringsService.strings['CONNECTED_TO_INTERFACE']}} &#10003;</div>
      }
      @if (!employee.export_to_paloma()) {
        <div class="not-connected">{{stringsService.strings['NOT_CONNECTED']}} &#10007;</div>
      }
    </div>
    <div class="interface-connection">
      @if (employee.current_contract && employee.current_contract.start_date) {
        <p class="valid">{{stringsService.strings['CURRENT_CONTRACT']}}</p>
      }
      @if (!employee.current_contract || !employee.current_contract.start_date) {
        <p class="invalid">{{stringsService.strings['CURRENT_CONTRACT']}}</p>
      }
      @if (employee.license && employee.license.license_number) {
        <p class="valid">{{stringsService.strings['LICENSE']}}</p>
      }
      @if (!employee.license || !employee.license.license_number) {
        <p class="invalid">{{stringsService.strings['LICENSE']}}</p>
      }
    </div>
  </div>
  <div style="clear:both"></div>
  <div class="app">
    <div class="app-icon-holder">
      <img class="app-icon" src="assets/img/artes-go-logo.png">
    </div>
    <div class="connection">
      @if (employee.export_to_artes()) {
        <div class="connected">{{stringsService.strings['CONNECTED_TO_INTERFACE']}} &#10003;</div>
      }
      @if (!employee.export_to_artes()) {
        <div class="not-connected">{{stringsService.strings['NOT_CONNECTED']}} &#10007;</div>
      }
    </div>
    <div class="interface-connection">
      @if (employee.license && employee.license.license_number) {
        <p class="valid">{{stringsService.strings['LICENSE']}}</p>
      }
      @if (!employee.license || !employee.license.license_number) {
        <p class="invalid">{{stringsService.strings['LICENSE']}}</p>
      }
      @if (employee.birth_date) {
        <p class="valid">{{stringsService.strings['BIRTH_DATE']}}</p>
      }
      @if (!employee.birth_date) {
        <p class="invalid">{{stringsService.strings['BIRTH_DATE']}}</p>
      }
      @if (employee.birth_place) {
        <p class="valid">{{stringsService.strings['BIRTH_PLACE']}}</p>
      }
      @if (!employee.birth_place) {
        <p class="invalid">{{stringsService.strings['BIRTH_PLACE']}}</p>
      }
      @if (employee.nationality_id) {
        <p class="valid">{{stringsService.strings['NATIONALITY']}}</p>
      }
      @if (!employee.nationality_id) {
        <p class="invalid">{{stringsService.strings['NATIONALITY']}}</p>
      }
      @if (employee.employer_id) {
        <p class="valid">{{stringsService.strings['EMPLOYER']}}</p>
      }
      @if (!employee.employer_id) {
        <p class="invalid">{{stringsService.strings['EMPLOYER']}}</p>
      }
    </div>
  </div>
</div>
